function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatternHeptagons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1284,
    height: 1336,
    viewBox: "0 0 1284 1336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M589.537 35.1259L999.781 232.689L1101.1 676.608L817.205 1032.6H361.869L77.9721 676.608L179.294 232.689L589.537 35.1259Z",
    stroke: "#142D35",
    style: {
      stroke: "#142D35",
      stroke: "color(display-p3 0.0768 0.1767 0.2082)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.537 35.1259L999.781 232.689L1101.1 676.608L817.205 1032.6H361.869L77.9721 676.608L179.294 232.689L589.537 35.1259Z",
    stroke: "#142D35",
    style: {
      stroke: "#142D35",
      stroke: "color(display-p3 0.0768 0.1767 0.2082)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.674 50.8625L804.257 12.7495L1151.15 386.612L1075.14 890.925L633.457 1145.93L158.704 959.602L8.37598 472.251L295.674 50.8625Z",
    stroke: "#142D35",
    style: {
      stroke: "#142D35",
      stroke: "color(display-p3 0.0768 0.1767 0.2082)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2304 380.16L524.468 60.2389L1067.16 227.636L1274.64 756.298L990.682 1248.13L429.105 1332.78L12.7897 946.492L55.2304 380.16Z",
    stroke: "#142D35",
    style: {
      stroke: "#142D35",
      stroke: "color(display-p3 0.0768 0.1767 0.2082)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.719 158.339L758.91 128.274L1032.55 423.193L972.592 821.015L624.176 1022.17L249.671 875.19L131.086 490.748L357.719 158.339Z",
    stroke: "#142D35",
    style: {
      stroke: "#142D35",
      stroke: "color(display-p3 0.0768 0.1767 0.2082)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.527 162.359L900.297 312.017L977.051 648.298L761.992 917.974H417.063L202.004 648.298L278.758 312.017L589.527 162.359Z",
    stroke: "#142D35",
    style: {
      stroke: "#142D35",
      stroke: "color(display-p3 0.0768 0.1767 0.2082)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.449 260.065L715.995 237.617L920.309 457.816L875.539 754.846L615.397 905.039L335.776 795.296L247.235 508.255L416.449 260.065Z",
    stroke: "#142D35",
    style: {
      stroke: "#142D35",
      stroke: "color(display-p3 0.0768 0.1767 0.2082)",
      strokeOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternHeptagons);
export default __webpack_public_path__ + "static/media/pattern_heptagons.3ed7f150110320be7aa7e7ad2afab290.svg";
export { ForwardRef as ReactComponent };